import { useEffect, useState } from "react";
import { getMensajexArea } from "../../../../services/public/areas";
import { getAreapCook } from "../../../../utils/params";
import Toasts from "../../../toast";
import MarqueeManual from "../../../../hooks/marquee";


function Bottom() {
  const [Mensajes, setMensajes] = useState([]);
  const [opciones, setOpciones] = useState([]);
  const [showToast, setShowToast] = useState(false);
  
  const getMensajes = async () => 
    {
      const AreaId = getAreapCook();
      const response = await getMensajexArea(AreaId);
      if (response) 
        {
          if (response.status === 200) 
            {
              setMensajes(response.data.data);
            } 
          else 
          {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);        
         }
       } 
   };

  useEffect(() => {
    const interval = setInterval(() => {
      getMensajes();
    }, 100);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <div className="fixed bottom-0 w-full h-[4.5rem] shadow-[-2px_-27px_26px_-4px_rgba(0,_0,_0,_0.1)] border-t-stone-200 px-6">
        {(Mensajes.length>0) && (
           <MarqueeManual mensajes={Mensajes}></MarqueeManual>
          ) 
        }
    </div>
    {showToast ? (
    <Toasts
      type={opciones.type}
      message={opciones.message}
      active={opciones.active}
    ></Toasts>
  ) : (
    ""
  )}
    </>
  );
}

export default Bottom;
